import { CountryBadge } from 'framework/form';
import React from 'react';
import { Box } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';

type OfficeAndAccommodationIconsProps = {
  registrations: string[];
  accommodations: string[];
};

const OfficeAndAccommodationIcons = ({ accommodations, registrations }: OfficeAndAccommodationIconsProps) => {
  return (
    <Box display="flex" gap={3}>
      <Tooltip title="Registration">
        <span>
          <Box display="flex" gap={1}>
            {registrations.map((item: string) => (
              <CountryBadge country={item} />
            ))}
          </Box>
        </span>
      </Tooltip>

      <Tooltip title="Accommodation">
        <span>
          <Box display="flex" gap={1}>
            {accommodations.map((item: string) => (
              <React.Fragment key={`accommodation-${item}`}>
                {item === 'ANYWHERE' ? (
                  <Box
                    component="i"
                    className="fa fa-globe"
                    sx={{ fontSize: '20px', color: 'info.main' }}
                    aria-hidden
                  />
                ) : (
                  <CountryBadge country={item} />
                )}
              </React.Fragment>
            ))}
          </Box>
        </span>
      </Tooltip>
    </Box>
  );
};

export default OfficeAndAccommodationIcons;
